module.exports = __webpack_public_path__ + "static/media/75.9ea2bff5.png";